<template>
    <div>
        <div class="innerMainContent">
            <div class="innerHeader">
                <div class="h1Wrap">
                    <svg class="i_profile"><use xlink:href="#i_profile"></use></svg>
                    <div class="innerH1Wrap">
                        <h1>{{ $t('myProfile') }}</h1>
                        <ul class="breadcrumb">
                            <li><router-link to="/">{{ $t('menu_hp') }}</router-link></li>
                            <li class="active">{{ $t('myProfile') }}</li>
                        </ul>
                    </div>
                </div>
                <div class="editEventActions">
                    <button class="backBtn" @click="this.$parent.goBack">
                        <span>{{ $t('back') }}</span>
                        <svg class="i_back"><use xlink:href="#i_longArr"></use></svg>
                    </button>
                </div>
            </div>
            <div class="innerBox">
                <form action="" id="editProfile" class="formWrap" @submit.prevent="submitForm">
                    <div class="row">
                        <div class="col-xs-12 containerWidth">
                            <div class="row">
                                <div class="col-xs-12">
                                    <h2>{{ $t('generalDetails') }}</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="fullName">*{{ $t('fullName') }}</label>
                                        <input type="text" maxlength="50" id="fullName" name="fullName" v-model="user.name" required>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="phone">{{ $t('phone') }} <span>({{ $t('mobile') }})</span></label>
                                        <input type="tel" id="phone" name="phone" v-model="user.phone">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="email">*{{ $t('email') }}</label>
                                        <input type="email" id="email" name="email" v-model="user.email" required>
                                    </div>
                                </div>
                            </div>

                            <br>
                            <br>
                            <div class="row">
                                <div class="col-xs-12">
                                    <h2>{{ $t('passwordUpdate') }}</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="currentPass">{{ $t('currentPassword') }}</label>
                                        <input type="password" minlength="6" id="currentPass" name="currentPass" v-model="user.currentPass">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="newPass">{{ $t('newPassword') }}</label>
                                        <password :badge="false" :secureLength="6" :required="false" :placeholder="null" id="newPass" name="newPass" v-model="user.newPass"></password>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="verifyNewPass">{{ $t('verifyNewPass') }}</label>
                                        <password :badge="false" :secureLength="6" :required="false" :placeholder="null" id="verifyNewPass" name="verifyNewPass" v-model="user.verifyNewPass"></password>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap submitWrap">
                                        <button class="submit">{{ $t('save') }}</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Password from 'vue-password-strength-meter'
    export default {
        name: 'Profile',
        data() {
            return {
                user:{},
            }
        },
        components:{
            Password
        },
        mounted(){
        },

        beforeMount(){
            this.$data.user = this.$store.state.user;
        },
        methods:{
            submitForm(){
                //check if updating password
                if(this.$data.user.currentPass != '' && this.$data.user.newPass != ''){
                    //check if passwords matching
                    if(this.$data.user.newPass != this.$data.user.verifyNewPass){
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('passwordsNotMatching'),
                            timer:3000
                        }).catch(this.$swal.noop);
                        return false;
                    }

                    if(typeof this.$data.newPass !=='undefined' && this.$data.newPass.length < 6){
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('passwordLength'),
                            timer:3000
                        }).catch(this.$swal.noop);
                        return false;
                    }
                }
                this.$store.dispatch('updateUser',this.$data.user)
                    .then(response => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'success',
                            title:this.$t('detailsSaved'),
                            timer:2000
                        }).catch(this.$swal.noop);
                    })
                    .catch(response => {
                        let err = this.$t('fatalError');
                        switch(response.code){
                            case -13:
                                err = this.$t('emailExist');
                                break;

                            case -12:
                                err = this.$t('fieldRequired_' + response.data.field);
                                break;

                            case -16:
                                err = this.$t('passwordsNotMatching');
                                break;

                            case -17:
                                err = this.$t('incorrectPassword');
                                break;
                        }
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:err,
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            }
        }
    }

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .editEventActions{
        float:left;
        margin-top: 6px;
    }
    .editEventActions .backBtn span{
        color:#7c97c5;
        font-weight:700;
        font-size:1.235rem;
        display:inline-block;
        vertical-align:middle;
    }
    .editEventActions .backBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:26px;
        height:18px;
        fill:#293b5a;
        margin-right:5px;
    }
    .editEventActions .deleteBtn{
        width:218px;
        height:54px;
        background: #fff;
        border:1px solid #d4d4d4;
        border-radius:27px;
        margin-left:30px;

    }
    .editEventActions .deleteBtn span{
        color:#293b5a;
        font-weight:700;
        font-size:1rem;
        display:inline-block;
        vertical-align:middle;
    }
    .editEventActions .deleteBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:19px;
        height:23px;
        fill:#849dc8;
        margin-left:10px;
    }
    .innerBox{
        padding:30px;
    }
    .h1Wrap svg.i_profile{
        width:26px;
        height:30px;
    }
</style>
